'use strict';
(function () {
  if (window.__VSKLO_ADDON_PDP_LOADER_V2__) return;
  window.__VSKLO_ADDON_PDP_LOADER_V2__ = true;

  var loader = window.VSKLOAssetLoader;
  if (!loader || typeof loader.loadScript !== 'function') {
    console.error('[VSKLO] shared asset loader is missing for PDP add-ons');
    return;
  }

  var bootScript = document.currentScript;
  var engineSrc = bootScript?.dataset
    ? String(bootScript.dataset.addonEngineSrc || '')
    : '';
  var controllerSrc = bootScript?.dataset
    ? String(bootScript.dataset.addonControllerSrc || '')
    : '';
  var loadPromise = null;

  function runtimeReady() {
    return Boolean(
      window.VSKLOAddonV3 &&
      typeof window.VSKLOAddonV3.init === 'function' &&
      typeof window.VSKLOInitPDPAddon === 'function'
    );
  }

  function ensureRuntime() {
    if (runtimeReady()) return Promise.resolve(true);
    if (loadPromise) return loadPromise;

    loadPromise = loader.loadScript({
      key: 'pdp-addon-engine',
      src: engineSrc,
      parent: 'head',
      ready: function () {
        return window.VSKLOAddonV3 &&
          typeof window.VSKLOAddonV3.init === 'function'
          ? window.VSKLOAddonV3
          : null;
      },
      label: 'PDP add-on engine'
    })
      .then(function () {
        return loader.loadScript({
          key: 'pdp-addon-controller',
          src: controllerSrc,
          parent: 'head',
          ready: function () {
            return typeof window.VSKLOInitPDPAddon === 'function'
              ? window.VSKLOInitPDPAddon
              : null;
          },
          label: 'PDP add-on controller'
        });
      })
      .then(function () {
        window.VSKLOAddonV3.init(document);
        window.VSKLOInitPDPAddon(document);

        if (!runtimeReady()) {
          throw new Error('PDP add-on runtime did not initialize');
        }
        return true;
      })
      .catch(function (error) {
        loadPromise = null;
        throw error;
      });

    return loadPromise;
  }

  window.VSKLOEnsurePDPAddon = ensureRuntime;

  function openerFrom(target) {
    return target && target.closest
      ? target.closest('.js-open-addons-popup')
      : null;
  }

  function warm(event) {
    var opener = openerFrom(event && event.target);
    if (!opener || runtimeReady()) return;

    ensureRuntime().catch(function (error) {
      if (window.VSKLO_DEBUG) {
        console.warn('[VSKLO] PDP add-on warmup skipped', error);
      }
    });
  }

  function handleClick(event) {
    var opener = openerFrom(event && event.target);
    if (!opener || runtimeReady()) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    opener.setAttribute('aria-busy', 'true');
    ensureRuntime()
      .then(function () {
        opener.removeAttribute('aria-busy');
        if (opener.isConnected) opener.click();
      })
      .catch(function (error) {
        opener.removeAttribute('aria-busy');
        console.error('[VSKLO] PDP add-on runtime failed to load', error);
      });
  }

  document.addEventListener('pointerover', warm, {
    capture: true,
    passive: true
  });
  document.addEventListener('pointerdown', warm, {
    capture: true,
    passive: true
  });
  document.addEventListener('touchstart', warm, {
    capture: true,
    passive: true
  });
  document.addEventListener('focusin', warm, true);
  document.addEventListener('click', handleClick, true);
})();